// extracted by mini-css-extract-plugin
export default {"slideContainer":"_3QVfK","slide":"_1-4Xc"};